// Components
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap'

export const Checkbox = ({
  id = Math.random().toString(36).substring(2, 7),
  onChange,
  children,
  errors,
  value,
  ...rest
}) => {
  return (
    <FormGroup check>
      <Input {...rest} checked={value} type="checkbox" id={id} onChange={onChange} invalid={Boolean(errors)} style={{ cursor: 'pointer' }} />{' '}

      <Label check for={id}>
        {children}
      </Label>

      <FormFeedback>{errors}</FormFeedback>
    </FormGroup>
  )
}